var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", { staticClass: "loading" })
        : _c("SetupConfirmation", {
            attrs: {
              loading: _vm.confirmationLoading,
              secret: _vm.secret,
              "qr-url": _vm.qrUrl,
              confirmation: _vm.confirmation
            },
            on: {
              "update:confirmation": function($event) {
                _vm.confirmation = $event
              },
              confirm: _vm.confirm
            }
          }),
      _vm._v(" "),
      _c("form", { ref: "confirmForm", attrs: { method: "POST" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }